import rest from "./restService";

let db = {};
export default class database {
    constructor(funcLoaded, funcProgress) {
        this.isLoad = 0;
        this.funcLoaded = funcLoaded;
        this.funcProgress = funcProgress;
        this.tables = {
            "Goods": 'goods/get-all-goods',
//            "PLU": 'goods-plu/index'
        }

        // for (const item in this.tables) {
        //     db[item] = [];
        // }

    }

    getOrgName(resFunc) {

        new rest().Recive('tsd/get-org', {}, (data) => {
            resFunc(data);
        });
    }
    load(apiUrl, name) {
        let restService = new rest();
        restService.Recive(apiUrl, {'time': 0}, (data) => {
            if (!db)
                db = {};
            db[name] = JSON.parse(data);
            console.log(name + ' ' + db[name].length + ' elements.');
            this.isLoad = this.isLoad - 1;
            if (this.isLoad === 0 && this.funcLoaded)
                this.funcLoaded();
        }, (e) => {
            console.log('Error by loading ' + name, e);
            this.isLoad = this.isLoad - 1;
            // db[name] = [];
            if (this.isLoad === 0 && this.funcLoaded)
                this.funcLoaded();
        }, this.funcProgress);
    }

    getData(resFunc) {
        resFunc(db);
    }

    loadAll(min = false) {
        if (min)
            this.tables['Goods'] = 'goods/get-min';
        for (const item in this.tables) {
            this.load(this.tables[item], item);
            this.isLoad = this.isLoad + 1;
        }
    }

    getBy(dbName, valueName, value, rFunc) {
        let found = false;
        if (db[dbName])
            for (let i = 0; i < db[dbName].length && found === false; i++) {
                if (db[dbName][i][valueName] === value) {
                    rFunc(db[dbName][i]);
                    found = true;
                }
                if (!found && i === db[dbName].length - 1) {
                    rFunc(-1)
                }

            }
        else rFunc(-1);
    }

    newSearch(str, resFunc) {
        this.getBy('Goods', 'barcode', str, (result) => {
            if (result !== -1) {
                result.qty = 1;
                resFunc(result);
            } else {
                if (str.substr(0, 1) === '2') {
                    let plu = parseInt(str.substr(2, 5)).toString();
                    this.getBy('Goods', 'plu', plu, (result) => {
                        if (result !== -1) {
                                    result.qty = parseFloat(str.substr(7, 5)) / 1000;
                                    resFunc(result)
                                } else resFunc(result);
                    });
                } else {
                    resFunc(result);
                }
            }
        })

    }

    search(str, resFunc) {
        this.getBy('Goods', 'barcode', str, (result) => {
            if (result !== -1) {
                result.qty = 1;
                resFunc(result);
            } else {
                if (str.substr(0, 1) === '2') {
                    let plu = parseInt(str.substr(2, 5)).toString();
                    this.getBy('Goods', 'plu', plu, (result) => {
                        if (result !== -1) {
                            this.getBy('Goods', 'id', result.goods_id, (result) => {
                                if (result !== -1) {
                                    result.qty = parseFloat(str.substr(7, 5)) / 1000;
                                    resFunc(result)
                                } else resFunc(result);
                            });
                        } else resFunc(result);
                    });
                } else {
                    resFunc(result);
                }
            }
        })

    }

    loaded() {
        return this.isLoad;
    }

    loadLocalStorage() {
        for (const item in this.tables) {
            let tDB = localStorage.getItem(item);
            if (tDB !== 'undefined') {
                db[item] = JSON.parse(tDB);
            }
        }
    }

    saveLocalStorage() {
        for (const item in this.tables) {
            try {
                localStorage.setItem(item, JSON.stringify(db[item]));
            } catch (error) {
                //this.loadLocalStorage(item, JSON.stringify([]));
                //console.log(error);
            }
        }
    }

}
